import styled, {css} from 'styled-components';
import {colors} from '../../../global.config';
import {ScreenSizes} from '../../../../types/responsive';

export const SectionHeader = styled.p<{marginTop?: string}>`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  margin-top: ${(props) => props.marginTop || '8px'};

  @media (max-width: ${ScreenSizes.md}) {
    font-weight: 600;
    font-size: 12px;
    color: #98999c;
    margin-top: 0;
    margin-bottom: 20px;
    text-transform: uppercase;
  }
`;

export const Item = styled.li`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 17px;
  color: #4c5065;

  svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  a {
    display: block;
    text-decoration: none;
    transition: 250ms color;

    :hover {
      color: ${colors.pink};
    }

    &.active {
      color: ${colors.pink};
    }
  }
`;

export const FeaturesList = styled.ul<{isLast?: boolean}>`
  padding: 0;
  list-style: none;
  margin: 0;
  gap: 8px;

  li {
    margin-bottom: 24px;
    align-items: start;

    @media (min-width: ${ScreenSizes.md}) {
      &:last-child {
        margin-bottom: 2px;
      }
    }
  }

  @media (max-width: ${ScreenSizes.md}) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 8px;
  }

  @media (max-width: 340px) {
    grid-template-columns: repeat(1, 100%);
    column-gap: 0;
  }
`;

// Desktop menu shared components
export const MenuItem = styled.li`
  display: flex;
  margin: 0 25px;
  position: relative;

  a {
    display: block;
    position: relative;
    text-decoration: none;
    transition: 250ms color;
    color: inherit;

    :hover {
      color: ${colors.pink};
    }

    &.active {
      color: ${colors.pink};
    }
  }
`;

export const LinkWrapper = styled.div`
  padding-bottom: 40px;
  padding-top: 40px;
  cursor: pointer;

  :hover {
    color: ${colors.pink};
  }
`;

export const TriangleArrow = styled.div<{visible: boolean; left?: string}>`
  position: absolute;
  top: -8px;
  left: ${(props) => props.left || 'calc(50% - 8px)'};
  width: 16px;
  height: 16px;
  transform: rotate(45deg);
  border-radius: 3px 0 0 0;
  background-color: white;
  box-shadow: -3px -3px 5px rgb(82 95 127 / 4%);
  z-index: 100;
  transition-property: transform;
  transition-duration: 125ms;
  opacity: 0;

  ${(props) =>
    props.visible &&
    css`
      opacity: 1;
      transform: rotate(45deg);
    `}
`;

export const Body = styled.div`
  padding: 24px;
`;

interface DropdownMenuProps {
  visible: boolean;
  minWidth?: string;
  left?: string;
  leftMobile?: string;
  column?: boolean;
}

export const DropdownMenu = styled.div<DropdownMenuProps>`
  width: auto;
  min-width: ${(props) => props.minWidth || '330px'};
  position: absolute;
  background: #ffffff;
  border-radius: 14px;
  z-index: 99;
  left: ${(props) => props.left || '0'};
  top: 80px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition:
    opacity 0.1s ease,
    transform 0.1s ease,
    visibility 0.1s;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);

  ${(props) =>
    props.visible &&
    css`
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    `};

  @media (max-width: ${ScreenSizes.lg}) {
    left: ${(props) => props.leftMobile || props.left || '0'};
  }

  ${(props) =>
    props.column &&
    css`
      display: flex;
      flex-direction: column;
      list-style: none;
      margin: 0;
      padding-top: 16px;
      padding-bottom: 24px;
      padding-left: 24px;
      padding-right: 24px;
    `};
`;

export const Grid2Columns = styled.div<{columnWidth?: string}>`
  display: grid;
  grid-template-columns: repeat(2, ${(props) => props.columnWidth || '1fr'});
  gap: 8px;

  @media (max-width: ${ScreenSizes.md}) {
    grid-template-columns: 1fr;
  }
`;
